// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MembersPanel__container-e55dec {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.MembersPanel__member-list-container-bbccbe {
  flex: 1 1;
  overflow-y: auto;
}

.MembersPanel__member-list-container-bbccbe::-webkit-scrollbar-track {
  background-color: var(--addition-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupVideoCall/MembersPanel/MembersPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.member-list-container {\n  flex: 1 1;\n  overflow-y: auto;\n}\n\n.member-list-container::-webkit-scrollbar-track {\n  background-color: var(--addition-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MembersPanel__container-e55dec`,
	"member-list-container": `MembersPanel__member-list-container-bbccbe`,
	"memberListContainer": `MembersPanel__member-list-container-bbccbe`
};
module.exports = ___CSS_LOADER_EXPORT___;
